import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxSelectModule } from 'ngx-select-ex';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { TasksComponent } from './header/tasks/tasks.component';
import { NavsearchComponent } from './header/navsearch/navsearch.component';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { UserblockComponent } from './sidebar/userblock/userblock.component';
import { UserblockService } from './sidebar/userblock/userblock.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MomentModule } from 'ngx-moment';
import { NotificationsComponent } from './header/notifications/notifications.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { HorizontalItemComponent } from './horizontal-item/horizontal-item.component';
import { ProductsComponent } from './header/products/products.component';
import { SupportChatComponent } from './header/support-chat/support-chat.component';
import { AnnouncementBannerComponent } from '@shared/components/announcement-banner/announcement-banner.component';

@NgModule({
    imports: [
        SharedModule,
        NgxSelectModule,
        FileUploadModule,
        NgxLoadingModule,
        MomentModule,
        NgxDatatableModule
    ],
    providers: [
        UserblockService
    ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        FooterComponent,
        TasksComponent,
        NotificationsComponent,
        HorizontalComponent,
        HorizontalItemComponent,
        ProductsComponent,
        SupportChatComponent,
        AnnouncementBannerComponent
    ],
    exports: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        FooterComponent,
        TasksComponent,
        NotificationsComponent,
        HorizontalComponent,
        HorizontalItemComponent,
        ProductsComponent,
        SupportChatComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LayoutModule { }
